<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c002">Fae-mous: A Why Choose YA/New Adult Paranormal Urban Romance (Fallen Fae B.I. Series, #2)</a></p>
<p><a href="#/c003">Note</a></p>
<p><a href="#/c004">Chapter 1 | Harley</a></p>
<p><a href="#/c005">Chapter 2</a></p>
<p><span href="#/c006" title="Link target outside of Sample">Chapter 3</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Chapter 4</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Chapter 5</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Chapter 6</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Chapter 7</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Chapter 8</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Chapter 9 | Oakley</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Chapter 10 | Oakley</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Chapter 11 | Harley</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Chapter 12 | Kingsley</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Chapter 13 | Kingsley</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Chapter 14 | Harley</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Chapter 15 | Harley</span></p>
<p><span href="#/c019" title="Link target outside of Sample">Chapter 16 | Harley</span></p>
<p><span href="#/c020" title="Link target outside of Sample">Chapter 17 | Harley</span></p>
<p><span href="#/c021" title="Link target outside of Sample">Epilogue | Harley</span></p>
<p><span href="#/c022" title="Link target outside of Sample">Thank You for reading</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Get a Free Gift from Romance on the Go!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?766185b4